import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import AttendanceList from '../attendance/AttendanceList';
import AttendanceCalendar from '../attendance/AttendanceCalendar';

const AttendanceRouter = () => {
  const { moduleName } = useParams();
  const navigate = useNavigate();

  const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
  const role = storedUser?.role_name;

  useEffect(() => {
    if (!moduleName) {
      if (role === 1) {
        navigate("/attendance-view/A", { replace: true });
      } else if (role === 2) {
        navigate("/attendance-view/C", { replace: true });
      }
    }
  }, [moduleName, role, navigate]);

  if (moduleName === 'A') {
    return <AttendanceList />;
  } else if (moduleName === 'C') {
    return <AttendanceCalendar />;
  } else if (!moduleName) {
    return null; // Redirection is handled
  } else {
    return <div>Invalid module</div>;
  }
};

export default AttendanceRouter;
